import { CriteriaIndicatorIcon } from 'app/components/core/icons';
import {
  getPasswordCriteriaRules,
  type PasswordCriterion,
} from './passwordCriteriaRules';
import * as S from './styles';

type PasswordCriteriaChecklistProps = {
  password: string;
  userName?: string;
  visible?: boolean;
  rules?: PasswordCriterion[];
};

function splitInColumns<T>(items: T[]): [T[], T[]] {
  const midpoint = Math.ceil(items.length / 2);
  return [items.slice(0, midpoint), items.slice(midpoint)];
}

function CriteriaColumn({
  password,
  rules,
}: {
  password: string;
  rules: PasswordCriterion[];
}) {
  return (
    <S.Column>
      {rules.map((rule) => {
        const met = rule.test(password);

        return (
          <S.Item
            key={rule.id}
            data-testid={`password-criterion-${rule.id}`}
            data-met={met}
          >
            <S.IconSlot aria-hidden={true}>
              <CriteriaIndicatorIcon met={met} />
            </S.IconSlot>
            <span>{rule.label}</span>
          </S.Item>
        );
      })}
    </S.Column>
  );
}

const PasswordCriteriaChecklist = ({
  password,
  userName,
  visible = false,
  rules,
}: PasswordCriteriaChecklistProps) => {
  const [leftRules, rightRules] = splitInColumns(
    rules ?? getPasswordCriteriaRules(userName),
  );

  return (
    <S.Reveal $visible={visible} aria-hidden={!visible}>
      <S.RevealInner>
        <S.Box aria-label="Critérios de senha">
          <CriteriaColumn password={password} rules={leftRules} />
          <CriteriaColumn password={password} rules={rightRules} />
        </S.Box>
      </S.RevealInner>
    </S.Reveal>
  );
};

export default PasswordCriteriaChecklist;
